<template>
    <div class="h-full bg-gray-100 w-64 border hidden sm:block">
        <h4 class="text-xl my-4 text-slate-600 font-medium tracking-tight mx-5">Style Editor</h4>

        <hr>

        <nav class="mt-5 mx-4 font-medium">
            <div class="my-1 p-2 rounded" :class="menuItemClasses('home')">
                <router-link :to="{ name: 'home' }">
                    <i class="far fa-home-lg-alt fa-lg mr-3"></i> Home
                </router-link>
            </div>

            <div class="my-1 p-2 rounded" :class="menuItemClasses('typography')">
                <router-link :to="{ name: 'typography' }">
                    <i class="far fa-font fa-lg mr-3"></i> Typography
                </router-link>
            </div>

            <div class="my-1 p-2 rounded" :class="menuItemClasses('colors')">
                <router-link :to="{ name: 'colors' }">
                    <i class="far fa-palette fa-lg mr-3"></i> Colors
                </router-link>
            </div>

            <div class="my-1 p-2 rounded" :class="menuItemClasses('components')">
                <router-link :to="{ name: 'components' }">
                    <i class="far fa-cubes fa-lg mr-3"></i> Components
                </router-link>
            </div>

        </nav>

    </div>
</template>

<script>
import NavRendererPlus from "../../../app/editor/page/NavRendererPlus.vue";
export default {
    name: 'Sidebar',
    components: {NavRendererPlus},
    props: ['prop1', 'prop2'],
    data () {
        return {
            model: webase.model
        }
    },
    mounted () {
    },
    methods: {
        menuItemClasses(routeName) {
            return this.$route.name === routeName ? 'bg-purple-600 text-white' : 'text-slate-600 hover:bg-white'
        }
    }
}
</script>
